// import { LettersLeft } from "./letters-left";
import $ from "jquery";
window.$ = $;
// import { validateForm } from "./validateForm";
// import { copyToClipboard } from "./copyToClipboard";
import "select2";
import { initAjaxAction } from "./ajax-action";
import {TomSelect} from './tom-select';
import initConfirm from "./confirm";
import './select-picker';

import IMask from "imask";
// LettersLeft($)('[maxlength]');
// validateForm('form.ea-edit-form, form.ea-new-form');
// copyToClipboard();

require("mdb-ui-kit/js/mdb.min")
require("./cms/menu")
require("./cms/page-struct")
require("./cms/contentbuilder")
require("datatables.net-dt");

initAjaxAction();
initConfirm();

$('.translation-locale-select').on('change', function() {
    window.location = $(this).data('href').replace('xx', $(this).val());
});

$('body').find('.o-clock-input').each(function () {
    if ($(this).val()) {
        $(this).closest('div').find('label').addClass('focused-label');
    }
});

$('body').on('focus', '.o-clock-input', function () {
    $(this).closest('div').find('label').addClass('focused-label');
}).on('focusout', '.o-clock-input', function () {
    if (!$(this).val()) {
        $(this).closest('div').find('label').removeClass('focused-label');
    }
});
